"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var promise_polyfill_1 = __importDefault(require("promise-polyfill"));
var TestWeblabClient = /** @class */ (function () {
    function TestWeblabClient(treamentSettings) {
        this.treamentSettings = treamentSettings;
    }
    // This is a noop for the test publisher.
    TestWeblabClient.prototype.setMetricsPublisher = function () { };
    TestWeblabClient.prototype.getTreatments = function (weblabs) {
        var _this = this;
        var treatmentMap = new Map();
        weblabs.forEach(function (w) {
            var treatmentValue = _this.treamentSettings[w.id];
            treatmentMap.set(w, {
                weblabId: w.id,
                treatmentValue: treatmentValue,
                recordTrigger: function () { return _this.recordTrigger(w, treatmentValue); },
            });
        });
        return promise_polyfill_1.default.resolve(treatmentMap);
    };
    TestWeblabClient.prototype.recordTrigger = function (_weblab, _treatment) {
        // do nothing this is just for testing
        return promise_polyfill_1.default.resolve();
    };
    return TestWeblabClient;
}());
exports.TestWeblabClient = TestWeblabClient;
